<template>
  <div>
    <titulo-modulo titulo="Documentos" />
    <v-tabs
      class="mt-3"
      grow
      v-model="tab"
      background-color="green lighten-4"
      active-class="font-weight-bold"
      slider-size="3"
    >
      <v-tab>Recebidos</v-tab>
      <v-tab>Enviados</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="mt-3">
          <v-card-text>
            <v-progress-linear
              indeterminate
              v-if="carregando"
            ></v-progress-linear>
            <v-alert
              v-else-if="documentos.length == 0"
              type="info"
              class="mt-2"
              text
            >
              Nenhum documento encontrado
            </v-alert>

            <template v-else-if="isMobile()">
              <v-list>
                <template v-for="(doc, i) in documentos">
                  <v-list-item :key="i">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">{{
                        doc.tipodocumento
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        v-if="doc.versao != ''"
                        class="mb-1"
                      >
                        <span>Versão {{ doc.versao }}</span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                        >{{ doc.cargo }} ({{ doc.empresa }}/{{ doc.estab }}/{{
                          doc.matr
                        }})</v-list-item-subtitle
                      >
                      <v-list-item-subtitle>
                        <small>Importado em {{ doc.datahoraimportacao }}</small>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon color="info" @click="abrirDocumento(doc)"
                        ><v-icon>mdi-download</v-icon></v-btn
                      >
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="i < documentos.length - 1"
                    :key="documentos.length * (i + 1)"
                  ></v-divider>
                </template>
              </v-list>
            </template>
            <template v-else>
              <v-data-table
                :items="documentos"
                :headers="headers"
                :disable-sort="$mq == 'sm'"
                single-expand
                show-expand
                item-key="iddocumento"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    rounded
                    color="info"
                    small
                    @click="abrirDocumento(item)"
                    :block="$mq === 'sm'"
                    >Abrir Arquivo</v-btn
                  >
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">{{ item.confirmacao }}</td>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <DoctosEnviados />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import axios from "axios";
import TituloModulo from "../../components/TituloModulo.vue";
import DoctosEnviados from "./components/OutrosDocumentos.vue";

import { getToken } from "@/global";

export default {
  components: { TituloModulo, DoctosEnviados },
  data: () => ({
    documentos: [],
    carregando: false,
    tab: 0,
    headers: [
      { text: "Emp", value: "empresa" },
      { text: "Est", value: "estab" },
      { text: "Matr", value: "matr" },
      { text: "Documento", value: "tipodocumento" },
      { text: "Versão", value: "versao" },
      { text: "Cargo", value: "cargo" },
      { text: "Inclusão", value: "datahoraimportacao" },
      { text: "", value: "actions", align: "center" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    async getDocumentos() {
      await axios
        .get(`colaborador/documentos`)
        .then((res) => {
          if (res.data.success) this.documentos = res.data.data;
          else this.$toasted.error(res.data.msg);
        })
        .catch((e) =>
          this.$toasted.error(`Houve um erro ao carregar os documentos. ${e}`)
        );
    },
    abrirDocumento(doc) {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/colaborador/documentos?funcao=EXIBIR&doc=${
          doc.iddocumento
        }&token=${getToken()}`,
        "blank"
      );
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getDocumentos();
    this.carregando = false;
  },
};
</script>

<style></style>
